import { IGif } from '@giphy/js-types'
import React from 'react'
import { useChannelGifPaginator } from 'shared/api/channels'
import BrandLoader from 'shared/components/brand-loader'
import Observer from 'shared/components/observer'
import VideoPreview from 'shared/components/video-preview-thumbnail'
import styled from 'styled-components'

const StyledVideoPreview = styled(VideoPreview)`
    margin-bottom: 30px;
`

export const Grid = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 30px;
    justify-content: space-between;
`

export const Loader = styled(BrandLoader)`
    margin-bottom: 50px;
`

// spaces grid to align items to the left
const PreviewSpacer = styled.div<{ previewWidth: number }>`
    height: 1px;
    width: ${props => props.previewWidth}px;
`

type Props = {
    gifs: IGif[]
    previewWidth?: number
    hideAttribution?: boolean
}

const VideoPreviewGrid = ({ gifs, previewWidth = 336, hideAttribution = false }: Props) => (
    <Grid>
        {gifs.map(gif => (
            <StyledVideoPreview key={gif.id} gif={gif} width={previewWidth} hideAttribution={hideAttribution} />
        ))}
        <PreviewSpacer previewWidth={previewWidth} />
    </Grid>
)

type ChannelGridProps = { channelId: number } & Props

export const VideoPreviewChannelGrid = ({ channelId, previewWidth, hideAttribution = false }: ChannelGridProps) => {
    const [gifs = [], fetchVideos, isDoneLoading] = useChannelGifPaginator(channelId, 'videos')
    return (
        <>
            <VideoPreviewGrid gifs={gifs} previewWidth={previewWidth} hideAttribution={hideAttribution} />
            {!isDoneLoading && (
                <Observer onVisible={fetchVideos} key={gifs.length}>
                    <Loader />
                </Observer>
            )}
        </>
    )
}

export default VideoPreviewGrid
